import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import styles from './Filter.module.scss'

const SearchTextInput = ({
  handleChange,
  placeholder = 'Type anything to filter',
  activeTab
}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.focus()
  }, [activeTab])

  return (
    <input
      ref={inputRef}
      autoFocus={true}
      type="search"
      placeholder={placeholder}
      className={styles.bar}
      onInput={e => handleChange(e.target.value)}
    />
  )
}

SearchTextInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

export default SearchTextInput
